import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { AppLayout } from './components/app/AppLayout';
import AppRoutes from './routes'; // You'll need to create this

function App() {
  console.log('App component rendering');
  
  useEffect(() => {
    console.log('App component mounted');
  }, []);

  return (
    <Router>
      <AuthProvider>
        <AppProvider>
          <AppLayout>
            <AppRoutes />
          </AppLayout>
        </AppProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
